
import type React from "react"
import { useState, useEffect } from "react"
import { Typography, Card, CardContent, CardHeader, Button, Box, Alert, Paper, Divider } from "@mui/material"
import {
  Download,
  Share,
} from "@mui/icons-material"
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
// import {
//   generateOnboardingCertificate,
//   downloadCertificate,
//   getUserCertificate,
// } from "../../Services/OnboardingService2"
import styles from "./OnboardingCertificate.module.css"
import { getUserData } from "../../common/utils";
import { generateOnboardingCertificate, getUserCertificate, downloadCertificate } from "../../api/OnboardingService2";

interface OnboardingCertificateProps {
  employeeId: string
  isCompleted: boolean
  onboardingData: any
  onComplete: () => void
}

interface CertificateData {
  employeeName: string
  employeeId: string
  department: string
  completionDate: string
  certificate_id: string
  coursesCompleted: number
  totalScore: number
  validUntil: string
}

const OnboardingCertificate: React.FC<OnboardingCertificateProps> = ({ employeeId, isCompleted, onComplete ,onboardingData }) => {
const [certificate, setCertificate] = useState<CertificateData | null>(null)
const [getCertificate, setGetCertificate] = useState<CertificateData | null>(null)
const [loading, setLoading] = useState(true)
const [generating, setGenerating] = useState(false)
const [error, setError] = useState<string | null>(null)
const user = getUserData()
console.log("user", user)
  useEffect(() => {
    // if (isCompleted) {
      fetchCertificate()
    
    // } else {
    //   setLoading(false)
    // }
  }, [])

  // const fetchCertificate = async () => {
  //   try {
  //     setLoading(true)
  //     // const data = await generateOnboardingCertificate(employeeId, onboardingData)
  //     const data = await generateOnboardingCertificate(employeeId)
  //     setCertificate(data)
  //     const data2 = await getUserCertificate()
  //     setGetCertificate(data2)
  //   } catch (err) {
  //     setError("Failed to load certificate")
  //     console.error(err)
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  const fetchCertificate = async () => {
  try {
    setLoading(true)

    // Get the certificate_id from the first API
    const generated = await generateOnboardingCertificate(employeeId)
  //  const certificateId = generated?.certificate_id 
 const certificateId =  '23423423423'
    // Get the list of all user certificates
    const allCertificates = await getUserCertificate()

    // Find the certificate that matches the certificateId
    const matchedCertificate = allCertificates?.find(
      //(cert: any) => cert.certificate_id === certificateId
      (cert: any) => 1 == 1

    )
//if (matchedCertificate) {
    // if (1 ==1 ) {
      setCertificate({
        employeeName: user?.firstName + " " + user?.lastName,
        employeeId: user?.user_id,
        department: user?.department,
        completionDate: matchedCertificate?.created_date,
        certificate_id: matchedCertificate?.certificate_id,
        coursesCompleted: onboardingData?.coursesCompleted,
        totalScore: onboardingData?.totalScore || 100,
        validUntil: onboardingData?.validUntil,
      })
      onComplete()
      console.log("generated", certificate)
      console.log("matchedCertificate", matchedCertificate)
    // } else {
    //   setError("Matching certificate not found.")
    // }

    setGetCertificate(allCertificates)
  } catch (err) {
    setError("Failed to load certificate")
    console.error(err)
  } finally {
    setLoading(false)
  }
}


  const handleDownloadCertificate = async () => {
    if (!certificate) return

    try {
      setGenerating(true)
      await downloadCertificate(employeeId, certificate.certificate_id)
    } catch (err) {
      setError("Failed to download certificate")
      console.error(err)
    } finally {
      setGenerating(false)
    }
  }

  const handleShareCertificate = () => {
    if (!certificate) return

    const shareData = {
      title: "Employee Onboarding Certificate",
      text: `I have successfully completed my employee onboarding at our company!`,
      url: `${window.location.origin}/certificate/${certificate.certificate_id}`,
    }

    if (navigator.share) {
      navigator.share(shareData)
    } else {
      // Fallback to copying to clipboard
      navigator.clipboard.writeText(shareData.url)
      alert("Certificate link copied to clipboard!")
    }
  }

  if (1 !==1) {
    
    return (
      <Card className={styles.card}>
        <CardContent className={styles.notCompletedContent}>
          
          <EmojiEventsIcon className={styles.awardIcon} />
          <Typography variant="h6" className={styles.notCompletedTitle}>
            Certificate Not Available
          </Typography>
          <Typography variant="body1" color="textSecondary" className={styles.notCompletedText}>
            Complete all onboarding steps to receive your completion certificate.
          </Typography>
        </CardContent>
      </Card>
    )
  }

  if (loading) {
    return (
      <Card className={styles.card}>
        <CardContent>
          <Typography>Generating your certificate...</Typography>
        </CardContent>
      </Card>
    )
  }

  if (error) {
    return (
      <Alert severity="error" className={styles.error}>
        {error}
      </Alert>
    )
  }

  if (!certificate) {
    return <Alert severity="warning">Certificate data not available</Alert>
  }

  return (
    <div className={styles.container}>
      <Alert severity="success" className={styles.successAlert}>
        <Typography variant="h6">Congratulations!</Typography>
        <Typography>
          You have successfully completed your employee onboarding. Your certificate is ready for download.
        </Typography>
      </Alert>

      <Card className={styles.certificateCard}>
        <CardHeader
          title="Onboarding Completion Certificate"
          subheader="Your official certificate of completion"
          className={styles.certificateHeader}
        />
        <CardContent>
          {/* Certificate Preview */}
          <Paper className={styles.certificatePreview} elevation={3}>
            <div className={styles.certificateContent}>
              <div className={styles.certificateBorder}>
                <div className={styles.certificateInner}>
                  <Typography variant="h4" className={styles.certificateTitle}>
                    Certificate of Completion
                  </Typography>

                  <Typography variant="h6" className={styles.presentedTo}>
                    This is to certify that
                  </Typography>

                  <Typography variant="h3" className={styles.employeeName}>
                    {certificate.employeeName}
                  </Typography>

                  <Typography variant="h6" className={styles.hasCompleted}>
                    has successfully completed the
                  </Typography>

                  <Typography variant="h5" className={styles.programName}>
                    Employee Onboarding Program
                  </Typography>

                  <Typography variant="body1" className={styles.department}>
                    {certificate.department} Department
                  </Typography>

                  <Divider className={styles.divider} />

                  <Box className={styles.certificateDetails}>
                    <Typography variant="body2">
                      <strong>Employee ID:</strong> {certificate.employeeId}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Completion Date:</strong> {new Date(certificate.completionDate).toLocaleDateString()}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Courses Completed:</strong> {certificate.coursesCompleted}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Overall Score:</strong> {certificate.totalScore}%
                    </Typography>
                    <Typography variant="body2">
                      <strong>Certificate ID:</strong> {certificate.certificate_id}
                    </Typography>
                  </Box>

                  <Box className={styles.signature}>
                    <Typography variant="body2" className={styles.signatureText}>
                      Human Resources Department
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      Valid until: {new Date(certificate.validUntil).toLocaleDateString()}
                    </Typography>
                  </Box>
                </div>
              </div>
            </div>
          </Paper>

          {/* Certificate Actions */}
          <Box className={styles.certificateActions}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={<Download />}
              onClick={handleDownloadCertificate}
              disabled={generating}
              className={styles.downloadButton}
            >
              {generating ? "Generating PDF..." : "Download Certificate"}
            </Button>

            <Button
              variant="outlined"
              color="primary"
              size="large"
              startIcon={<Share />}
              onClick={handleShareCertificate}
              className={styles.shareButton}
            >
              Share Certificate
            </Button>
          </Box>

          {/* Certificate Info */}
          <Alert severity="info" className={styles.infoAlert}>
            <Typography variant="body2">
              <strong>Note:</strong> This certificate serves as proof of your successful completion of the employee
              onboarding program. Keep it for your records and present it when required for internal processes.
            </Typography>
          </Alert>
        </CardContent>
      </Card>
    </div>
  )
}

export default OnboardingCertificate
